module.exports = __webpack_public_path__ + "img/sprinkle-13.6512d8e4.webp";